import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=68ddd86a&scoped=true"
import script from "./AuthHeader.vue?vue&type=script&lang=js"
export * from "./AuthHeader.vue?vue&type=script&lang=js"
import style0 from "./AuthHeader.vue?vue&type=style&index=0&id=68ddd86a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ddd86a",
  null
  
)

export default component.exports